import React from 'react';

const TestComplete = () => {
  return (
    <div className="test-complete-container">
      <div className="complete-card">
        <div className="success-icon">✓</div>
        <h1>¡Prueba Completada!</h1>
        <p>
          Gracias por completar las evaluaciones. Tus respuestas han sido registradas 
          exitosamente.
        </p>
        <p>
          Recibirás los resultados en tu correo electrónico una vez que sean procesados.
        </p>
        <p className="closing-message">
          Puedes cerrar esta ventana ahora.
        </p>
      </div>
    </div>
  );
};

export default TestComplete;